import SiteLoader from "./SiteLoader";
import SiteTransition from "./SiteTransition";
//import SearchTransition from "./SearchTransition";

export default [
  new SiteLoader(), 
  new SiteTransition()
];
